import React from "react";
import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    border: "1px solid #E8E8E8",
    boxShadow: "0px 12px 24px 0px #00000014",
    padding: 16,
    minHeight: 50,
    borderRadius: 10,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    fontSize: 20,
    "&:before": {
      border: "1px solid #E8E8E8",
    },
  },
}));
